import React, { Component, Fragment } from "react"
import { isEmpty } from "lodash"
import Cover from "components/landing/Cover"
import Featured from "components/landing/Featured"
import PageContainer from "components/common/PageContainer"
import CardList from "components/common/CardList"
import Button from "components/common/Button"

import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"

import { fetchFeaturedMaterial, fetchTopCourses } from "store/landing/action"

import history from "app/history"

import "styles/pages/landing.scss"

class LandingPage extends Component {
  componentDidMount() {
    const {
      school: { schoolData },
      fetchFeaturedMaterial,
      fetchTopCourses,
    } = this.props

    if (!isEmpty(schoolData)) {
      fetchFeaturedMaterial(schoolData.id)
      fetchTopCourses(schoolData.id)
    }
  }

  componentDidUpdate(prevProps) {
    const {
      school: { schoolData: prevSchoolData = {} },
    } = prevProps

    const {
      school: { schoolData = {} },
      fetchFeaturedMaterial,
      fetchTopCourses,
    } = this.props

    if (schoolData.id && prevSchoolData.id !== schoolData.id) {
      fetchFeaturedMaterial(schoolData.id)
      fetchTopCourses(schoolData.id)
    }
  }

  render() {
    const {
      landing: {
        featuredCourse,
        topCourses,
        isLoadingTopCourses,
        isLoadingFeaturedCourse,
      },
      school: { schoolData, isLoadingSocials },
    } = this.props

    // featuredCourse = {}

    return (
      <Fragment>
        <PageContainer
          isPageLoading={
            isLoadingTopCourses || isLoadingFeaturedCourse || isLoadingSocials
          }
        >
          <Cover data={schoolData} />
          <div className="featured-wrapper">
            <div className="text">
              <h3 className="headline">
                Our featured{" "}
                {featuredCourse.type === "bundle" ? "bundle" : "course"}
              </h3>
              <p className="explainer">
                Carefully hand picked by people who know the area best.
              </p>
            </div>
            <Featured featuredCourse={featuredCourse} />
          </div>
          <div
            className="courses-header"
            style={{ borderColor: schoolData.primary_color }}
          >
            <h3 className="headline">Our courses</h3>
            <p className="explainer">
              Browse through courses and choose what's right for you.
            </p>
          </div>
          <div className="course-cards">
            {topCourses && topCourses.length ? (
              <>
                <CardList
                  data={topCourses}
                  loading={isLoadingTopCourses}
                  isFeatured={true}
                />
                <Button
                  outlined
                  label="View All Courses"
                  onClick={() => history.push("/courses")}
                />
              </>
            ) : (
              <span className="font-l"> No courses to display</span>
            )}
          </div>
        </PageContainer>
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  school: state.schoolReducer,
  landing: state.landingReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ fetchTopCourses, fetchFeaturedMaterial }, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(LandingPage)
